import React, { useState } from "react";
import { Collapse, IconButton, Typography, Box, Paper } from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";

const ExpandableSection = ({
  title = "Section",
  children,
  initiallyExpanded = false,
  sx = {},
}) => {
  const [expanded, setExpanded] = useState(initiallyExpanded);

  const toggleExpand = () => setExpanded((prev) => !prev);

  return (
    <Paper elevation={2} sx={{ width: "100%", ...sx, overflow: "hidden" }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        px={2}
        py={1.5}
        sx={{
          backgroundColor: "#ffffff",
          cursor: "pointer",
          userSelect: "none",
        }}
        onClick={toggleExpand}
      >
        <Typography variant="subtitle1" fontWeight={600}>
          {title}
        </Typography>
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            toggleExpand();
          }}
          size="small"
        >
          {expanded ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </Box>
      {/* Animated divider */}
      <Box
        sx={{
          height: 3,
          width: expanded ? "100%" : "0%",
          background: "linear-gradient(90deg, #1976d2 30%, #42a5f5 90%)",
          transition: "width 0.4s cubic-bezier(0.4,0,0.2,1)",
          margin: "0 auto",
        }}
      />
      <Collapse in={expanded} timeout={1000} unmountOnExit>
        <Box p={2}>{children}</Box>
      </Collapse>
    </Paper>
  );
};

export default ExpandableSection;
